<div class="d-flex flex-column w-100">
  <div class="d-flex flex-wrap flex-sm-nowrap container gap-3">
    <div class="d-flex flex-column col-12 col-sm-6">
      <app-ashgrid-appellation class="mb-0"></app-ashgrid-appellation>

      <!-- INFO Headline -->
      <div class="d-flex flex-column mt-5">
        <p class="fw-normal" style="font-size: 56px; line-height: normal;">Reset your password</p>
      </div>
    </div>

    <div class="d-flex flex-column col-12 col-sm-6 mt-3 mt-sm-0 mxw-420px">
      <mat-stepper #stepper>
        <!-- INFO Initialize reset -->
        <mat-step>
          <div class="d-flex mx-auto p-2e">
            <p class="mb-0 text-left mat-headline-5 fw-normal">Enter your email to reset password</p>
          </div>

          <form [formGroup]="form" class="d-flex flex-column w-100 mt-4">
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" type="email" placeholder="Email">
              <mat-icon matSuffix class="material-symbols-outlined">mail</mat-icon>
            </mat-form-field>

            <button mat-flat-button class="mt-1 px-3 py-4 fw-bold rounded-3e" color="primary" [disabled]="inProgress || form.invalid"
                    (click)="initializePasswordReset(stepper)">
              <span class="my-auto mat-body-1 fw-bold">Reset password</span>
            </button>

            <a [routerLink]="getLoginRoute" [queryParams]="queryParams" mat-button class="mt-2 mat-body-1 rounded-3e">
              <span class="my-auto mat-body">Back to login</span>
            </a>
          </form>
        </mat-step>

        <!-- INFO Information -->
        <mat-step>
          <div class="d-flex flex-column w-100">
            <div class="d-flex mx-auto p-2e">
              <p class="mb-0 text-left mat-headline-5 fw-normal">Reset password</p>
            </div>

            <p class="mx-auto my-4 mb-0">
              If there is an existing account for "{{ email }}" you will receive an email with instructions
              on how to reset
              your
              password. Be sure to check your spam folder if you don't receive one.
            </p>

            <button mat-flat-button class="w-fit-content mx-auto my-4 px-3 py-4 fw-bold rounded-3e" color="primary" (click)="goToChangePasswordScreen()">
              <span class="my-auto mat-body-1 fw-bold">Continue (Reset Password)</span>
            </button>
          </div>
        </mat-step>
      </mat-stepper>
    </div>
  </div>
</div>
